import axios from "axios";
import router from "@/router";

axios.defaults.baseURL =  process.env.VUE_APP_API_BASE
axios.defaults.timeout = 100000

if( window.localStorage.getItem('jwt') ) {
    axios.defaults.headers = {
        Authorization: `Bearer ${ window.localStorage.getItem('jwt')}`
    }
}
axios.interceptors.response.use((response) => {
    if(response.status === 401) {
        alert("You are not authorized");
    }
    return response;
}, (error) => {
    if (error.response && error.response.data) {
        console.log(error);

        let {code, statusCode} = error.response.data;
        if(code === 'jwt_auth_invalid_token' && statusCode === 401) {
            localStorage.removeItem('jwt');
            localStorage.removeItem('user');
            router.push('/login');
        }
        return Promise.reject(error.response.data);
    }
    return Promise.reject(error.message);
});
export default axios;
